// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
import { SmartTable } from '../../../components/smart-table/smart-table.model';
import { SpAlert } from '../../../components/sp-alert/sp-alert.model';

/** @ngInject */
export function Controller(
    $scope,
    $state,
    Alert,
    DestructiveOperationModal,
    DomainsService,
) {
    $scope.st = new SmartTable();
    const companyId = $state.params.companyId;
    this.$onInit = () => $scope.domains = this.domains;

    $scope.setChoosenDomain = function(object) {
        $scope.chosenDomain = object;
    }

    $scope.showRemoveDomainDestructiveOp = function(keepAccounts) {
        var domainObject = $scope.chosenDomain;
        const url = `app/rest/${companyId}/domains/${domainObject.id}?keepAccounts=${keepAccounts}`;
        DestructiveOperationModal({
            titleKey: 'domains.delete_modal.header',
            textKey: 'domains.delete_modal.content',
            http: {method: 'DELETE', url}
        }).then(() => {
            Alert('success', 'domains.message.removed');
            $scope.domains.splice($scope.domains.indexOf(domainObject), 1);
        });
    }

    $scope.clearAddNewDomain = function() {
        $scope.domain = {
            "email" : null
        };
    };

    $scope.createNewDomain = function() {
        DomainsService.save({
            companyId : companyId,
            emailAddress : $scope.domain.email
        }, {}, function(data) {

            Alert('success', 'domains.message.added');
            $scope.domains.push(data);
            $('#addNewDomainModal').modal('hide');
            $scope.clearAddNewDomain();

        }, function(error) {
            $scope.domainInputMessage = new SpAlert('danger', error.data.message);
        });
    };

    $scope.clearAddNewDomain();
}



// WEBPACK FOOTER //
// ./src/portal/states/company/domains/domains.controller.js